import script from "./Deductions.vue?vue&type=script&setup=true&lang=ts"
export * from "./Deductions.vue?vue&type=script&setup=true&lang=ts"

import "./Deductions.vue?vue&type=style&index=0&id=57f2b71c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57f2b71c"]])

export default __exports__